import { validateListener } from "./validate";
import { NitroModules } from "react-native-nitro-modules";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneMotion");
  return hybrid;
}
function getAvailability() {
  return native().getAvailability();
}
function addListener(sensor, intervalMs, onReading, onError) {
  validateListener(sensor, intervalMs, onReading, onError);
  return native().addListener(sensor, intervalMs, onReading, onError);
}
var Motion = Object.freeze({
  getAvailability,
  addListener
});
export {
  Motion
};
//# sourceMappingURL=index.native.js.map
